import type ScreenKey from '@/Enums/Screens/ScreenKey.enum';
import type { FieldValues } from 'react-hook-form';
import {
  MUTUALY_EXCLUSIVE_CAMPAIGN_SCREENS,
  MUTUALY_EXCLUSIVE_CAMPAIGN_SCREEN_LABELS,
} from '../userManagement/userForm';

export const USER_MANAGEMENT_ACCESS_CONTROL_RULES = {
  validate: (_: any, fieldValues: FieldValues) => {
    const accessManagement: [ScreenKey, unknown][] = Object.entries(fieldValues.accessManagement || {}).filter(
      ([, _value]) => Boolean(_value),
    ) as [ScreenKey, unknown][];

    if (!accessManagement.length) return 'Please select at least one screen.';
    if (
      accessManagement.filter(([key]) => MUTUALY_EXCLUSIVE_CAMPAIGN_SCREENS.includes(key)).length ===
      MUTUALY_EXCLUSIVE_CAMPAIGN_SCREENS.length
    )
      return `The following screens are mutually exclusive: ${MUTUALY_EXCLUSIVE_CAMPAIGN_SCREEN_LABELS.join(', ')}`;
    return true;
  },
};
